import { ReturnStruct } from '../../structs/return.struct';

export class UsuarioLoginResponse extends ReturnStruct {
  idUser: number;
  userName: string;
  userEmail: string;
  timezone: number;
  listPermissions: number[] = [];
  token: string;
  zipcode: string;
}
 